// @generated by protoc-gen-es v1.2.0 with parameter "target=ts,import_extension=.ts"
// @generated from file protogen/calendar_service.proto (package protogen, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { ContentUpdates } from "./notes_pb.ts";
import { CalendarEvent, EventNotice, EventReminder, RecurringUnit } from "./calendar_pb.ts";
import { UploadAttachment } from "./common_pb.ts";

/**
 * @generated from message protogen.CreateCalendarEventRequest
 */
export class CreateCalendarEventRequest extends Message<CreateCalendarEventRequest> {
  /**
   * Optional
   *
   * @generated from field: string familyRef = 1;
   */
  familyRef = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: protogen.ContentUpdates description = 3;
   */
  description?: ContentUpdates;

  /**
   * @generated from field: int64 startSecUTC = 4;
   */
  startSecUTC = protoInt64.zero;

  /**
   * @generated from field: int64 endSecUTC = 5;
   */
  endSecUTC = protoInt64.zero;

  /**
   * @generated from field: bool allDay = 6;
   */
  allDay = false;

  /**
   * For all day events we need to specifically store the start and end dates so there's no
   * ambiguity on timezone converted dates.
   *
   * @generated from field: string startDisplayDate = 7;
   */
  startDisplayDate = "";

  /**
   * @generated from field: string endDisplayDate = 8;
   */
  endDisplayDate = "";

  /**
   * @generated from field: protogen.RecurringUnit recurringUnit = 10;
   */
  recurringUnit = RecurringUnit.RecurringUnit_UNSPECIFIED;

  /**
   * @generated from field: int32 recurringInterval = 11;
   */
  recurringInterval = 0;

  /**
   * @generated from field: int64 recurringUntilSecUTC = 12;
   */
  recurringUntilSecUTC = protoInt64.zero;

  /**
   * Email addresses.
   *
   * @generated from field: repeated string invitees = 13;
   */
  invitees: string[] = [];

  /**
   * @generated from field: string sourceEntityType = 14;
   */
  sourceEntityType = "";

  /**
   * @generated from field: string sourceEntityRef = 15;
   */
  sourceEntityRef = "";

  /**
   * @generated from field: int32 sourceEntityIndex = 16;
   */
  sourceEntityIndex = 0;

  /**
   * @generated from field: repeated protogen.EventReminder reminders = 17;
   */
  reminders: EventReminder[] = [];

  /**
   * @generated from field: string displayTimezone = 18;
   */
  displayTimezone = "";

  /**
   * @generated from field: string location = 19;
   */
  location = "";

  /**
   * @generated from field: bool isRecurringSingleInstance = 20;
   */
  isRecurringSingleInstance = false;

  /**
   * @generated from field: string originalEventRef = 21;
   */
  originalEventRef = "";

  /**
   * @generated from field: int64 originalEventStartSec = 22;
   */
  originalEventStartSec = protoInt64.zero;

  /**
   * @generated from field: string transparency = 23;
   */
  transparency = "";

  /**
   * @generated from field: string videoRef = 24;
   */
  videoRef = "";

  /**
   * If specified, write to this external calendar integration
   *
   * @generated from field: string targetIntegrationRef = 25;
   */
  targetIntegrationRef = "";

  /**
   * @generated from field: string targetCalendarId = 26;
   */
  targetCalendarId = "";

  /**
   * Advanced recurrence options
   *
   * Days of week [0-6] for Sun-Sat
   *
   * @generated from field: repeated int32 recurringByDay = 27;
   */
  recurringByDay: number[] = [];

  /**
   * End after X occurrences (0 means not set)
   *
   * @generated from field: int32 recurringCount = 28;
   */
  recurringCount = 0;

  /**
   * Days of month [1-31]
   *
   * @generated from field: repeated int32 recurringByMonthDay = 29;
   */
  recurringByMonthDay: number[] = [];

  /**
   * E.g., 2 for "2nd Tuesday" (0 means not set)
   *
   * @generated from field: int32 recurringBySetPos = 30;
   */
  recurringBySetPos = 0;

  /**
   * @generated from field: string meta = 31;
   */
  meta = "";

  /**
   * @generated from field: bool notifyCalendarOwner = 32;
   */
  notifyCalendarOwner = false;

  /**
   * @generated from field: string visibility = 33;
   */
  visibility = "";

  constructor(data?: PartialMessage<CreateCalendarEventRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CreateCalendarEventRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "familyRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "message", T: ContentUpdates },
    { no: 4, name: "startSecUTC", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "endSecUTC", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "allDay", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "startDisplayDate", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "endDisplayDate", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "recurringUnit", kind: "enum", T: proto3.getEnumType(RecurringUnit) },
    { no: 11, name: "recurringInterval", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "recurringUntilSecUTC", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 13, name: "invitees", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 14, name: "sourceEntityType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "sourceEntityRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "sourceEntityIndex", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 17, name: "reminders", kind: "message", T: EventReminder, repeated: true },
    { no: 18, name: "displayTimezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "location", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "isRecurringSingleInstance", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 21, name: "originalEventRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "originalEventStartSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 23, name: "transparency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 24, name: "videoRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 25, name: "targetIntegrationRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 26, name: "targetCalendarId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 27, name: "recurringByDay", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 28, name: "recurringCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 29, name: "recurringByMonthDay", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 30, name: "recurringBySetPos", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 31, name: "meta", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 32, name: "notifyCalendarOwner", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 33, name: "visibility", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateCalendarEventRequest {
    return new CreateCalendarEventRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateCalendarEventRequest {
    return new CreateCalendarEventRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateCalendarEventRequest {
    return new CreateCalendarEventRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateCalendarEventRequest | PlainMessage<CreateCalendarEventRequest> | undefined, b: CreateCalendarEventRequest | PlainMessage<CreateCalendarEventRequest> | undefined): boolean {
    return proto3.util.equals(CreateCalendarEventRequest, a, b);
  }
}

/**
 * @generated from message protogen.CreateCalendarEventResponse
 */
export class CreateCalendarEventResponse extends Message<CreateCalendarEventResponse> {
  /**
   * @generated from field: protogen.CalendarEvent event = 1;
   */
  event?: CalendarEvent;

  /**
   * @generated from field: protogen.EventNotice notice = 2;
   */
  notice?: EventNotice;

  constructor(data?: PartialMessage<CreateCalendarEventResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CreateCalendarEventResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "event", kind: "message", T: CalendarEvent },
    { no: 2, name: "notice", kind: "message", T: EventNotice },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateCalendarEventResponse {
    return new CreateCalendarEventResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateCalendarEventResponse {
    return new CreateCalendarEventResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateCalendarEventResponse {
    return new CreateCalendarEventResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateCalendarEventResponse | PlainMessage<CreateCalendarEventResponse> | undefined, b: CreateCalendarEventResponse | PlainMessage<CreateCalendarEventResponse> | undefined): boolean {
    return proto3.util.equals(CreateCalendarEventResponse, a, b);
  }
}

/**
 * @generated from message protogen.CreateMultipleCalendarEventsRequest
 */
export class CreateMultipleCalendarEventsRequest extends Message<CreateMultipleCalendarEventsRequest> {
  /**
   * @generated from field: string familyRef = 1;
   */
  familyRef = "";

  /**
   * @generated from field: string calendarName = 2;
   */
  calendarName = "";

  /**
   * @generated from field: repeated protogen.CreateMultipleCalendarEventsRequest.AbridgedCreateCalendarEvent events = 3;
   */
  events: CreateMultipleCalendarEventsRequest_AbridgedCreateCalendarEvent[] = [];

  /**
   * @generated from field: string sourceEntityType = 4;
   */
  sourceEntityType = "";

  /**
   * @generated from field: string sourceEntityRef = 5;
   */
  sourceEntityRef = "";

  constructor(data?: PartialMessage<CreateMultipleCalendarEventsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CreateMultipleCalendarEventsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "familyRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "calendarName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "events", kind: "message", T: CreateMultipleCalendarEventsRequest_AbridgedCreateCalendarEvent, repeated: true },
    { no: 4, name: "sourceEntityType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "sourceEntityRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateMultipleCalendarEventsRequest {
    return new CreateMultipleCalendarEventsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateMultipleCalendarEventsRequest {
    return new CreateMultipleCalendarEventsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateMultipleCalendarEventsRequest {
    return new CreateMultipleCalendarEventsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateMultipleCalendarEventsRequest | PlainMessage<CreateMultipleCalendarEventsRequest> | undefined, b: CreateMultipleCalendarEventsRequest | PlainMessage<CreateMultipleCalendarEventsRequest> | undefined): boolean {
    return proto3.util.equals(CreateMultipleCalendarEventsRequest, a, b);
  }
}

/**
 * @generated from message protogen.CreateMultipleCalendarEventsRequest.AbridgedCreateCalendarEvent
 */
export class CreateMultipleCalendarEventsRequest_AbridgedCreateCalendarEvent extends Message<CreateMultipleCalendarEventsRequest_AbridgedCreateCalendarEvent> {
  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: string description = 3;
   */
  description = "";

  /**
   * ISO 8601 format (e.g., '2024-01-15T10:00:00').
   *
   * @generated from field: string start = 4;
   */
  start = "";

  /**
   * @generated from field: string end = 5;
   */
  end = "";

  /**
   * @generated from field: bool allDay = 6;
   */
  allDay = false;

  /**
   * Email addresses.
   *
   * @generated from field: repeated string invitees = 13;
   */
  invitees: string[] = [];

  /**
   * @generated from field: string displayTimezone = 18;
   */
  displayTimezone = "";

  /**
   * @generated from field: string location = 19;
   */
  location = "";

  /**
   * @generated from field: int32 sourceIndex = 20;
   */
  sourceIndex = 0;

  constructor(data?: PartialMessage<CreateMultipleCalendarEventsRequest_AbridgedCreateCalendarEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CreateMultipleCalendarEventsRequest.AbridgedCreateCalendarEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "start", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "end", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "allDay", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "invitees", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 18, name: "displayTimezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "location", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "sourceIndex", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateMultipleCalendarEventsRequest_AbridgedCreateCalendarEvent {
    return new CreateMultipleCalendarEventsRequest_AbridgedCreateCalendarEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateMultipleCalendarEventsRequest_AbridgedCreateCalendarEvent {
    return new CreateMultipleCalendarEventsRequest_AbridgedCreateCalendarEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateMultipleCalendarEventsRequest_AbridgedCreateCalendarEvent {
    return new CreateMultipleCalendarEventsRequest_AbridgedCreateCalendarEvent().fromJsonString(jsonString, options);
  }

  static equals(a: CreateMultipleCalendarEventsRequest_AbridgedCreateCalendarEvent | PlainMessage<CreateMultipleCalendarEventsRequest_AbridgedCreateCalendarEvent> | undefined, b: CreateMultipleCalendarEventsRequest_AbridgedCreateCalendarEvent | PlainMessage<CreateMultipleCalendarEventsRequest_AbridgedCreateCalendarEvent> | undefined): boolean {
    return proto3.util.equals(CreateMultipleCalendarEventsRequest_AbridgedCreateCalendarEvent, a, b);
  }
}

/**
 * @generated from message protogen.CreateMultipleCalendarEventsResponse
 */
export class CreateMultipleCalendarEventsResponse extends Message<CreateMultipleCalendarEventsResponse> {
  /**
   * @generated from field: repeated protogen.CalendarEvent events = 1;
   */
  events: CalendarEvent[] = [];

  constructor(data?: PartialMessage<CreateMultipleCalendarEventsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CreateMultipleCalendarEventsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "events", kind: "message", T: CalendarEvent, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateMultipleCalendarEventsResponse {
    return new CreateMultipleCalendarEventsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateMultipleCalendarEventsResponse {
    return new CreateMultipleCalendarEventsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateMultipleCalendarEventsResponse {
    return new CreateMultipleCalendarEventsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateMultipleCalendarEventsResponse | PlainMessage<CreateMultipleCalendarEventsResponse> | undefined, b: CreateMultipleCalendarEventsResponse | PlainMessage<CreateMultipleCalendarEventsResponse> | undefined): boolean {
    return proto3.util.equals(CreateMultipleCalendarEventsResponse, a, b);
  }
}

/**
 * @generated from message protogen.ListEventsRequest
 */
export class ListEventsRequest extends Message<ListEventsRequest> {
  /**
   * @generated from field: repeated string familyRefs = 1;
   */
  familyRefs: string[] = [];

  /**
   * @generated from field: int32 month = 2;
   */
  month = 0;

  /**
   * @generated from field: int32 year = 3;
   */
  year = 0;

  /**
   * @generated from field: bool ignoreTasks = 4;
   */
  ignoreTasks = false;

  /**
   * @generated from field: bool ignoreEvents = 5;
   */
  ignoreEvents = false;

  /**
   * @generated from field: bool includeOverdueTasks = 6;
   */
  includeOverdueTasks = false;

  /**
   * @generated from field: bool includeExternalEvents = 7;
   */
  includeExternalEvents = false;

  /**
   * @generated from field: bool includeAdvisorEvents = 8;
   */
  includeAdvisorEvents = false;

  /**
   * @generated from field: bool forceIncludeUnreadEvents = 9;
   */
  forceIncludeUnreadEvents = false;

  /**
   * @generated from field: bool includeDuplicateEvents = 10;
   */
  includeDuplicateEvents = false;

  constructor(data?: PartialMessage<ListEventsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListEventsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "familyRefs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "month", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "ignoreTasks", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "ignoreEvents", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "includeOverdueTasks", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "includeExternalEvents", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "includeAdvisorEvents", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "forceIncludeUnreadEvents", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "includeDuplicateEvents", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListEventsRequest {
    return new ListEventsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListEventsRequest {
    return new ListEventsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListEventsRequest {
    return new ListEventsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListEventsRequest | PlainMessage<ListEventsRequest> | undefined, b: ListEventsRequest | PlainMessage<ListEventsRequest> | undefined): boolean {
    return proto3.util.equals(ListEventsRequest, a, b);
  }
}

/**
 * @generated from message protogen.ListEventsResponse
 */
export class ListEventsResponse extends Message<ListEventsResponse> {
  /**
   * @generated from field: repeated protogen.EventNotice eventNotices = 1;
   */
  eventNotices: EventNotice[] = [];

  /**
   * @generated from field: repeated protogen.ListEventsResponse.EventCalendar calendars = 2;
   */
  calendars: ListEventsResponse_EventCalendar[] = [];

  /**
   * Whether the user was invited to the event, let's us add family events with an invted advisor
   * to their "My events" filter
   *
   * @generated from field: repeated protogen.ListEventsResponse.UserAttendeeStatus userAttendeeStatuses = 3;
   */
  userAttendeeStatuses: ListEventsResponse_UserAttendeeStatus[] = [];

  constructor(data?: PartialMessage<ListEventsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListEventsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "eventNotices", kind: "message", T: EventNotice, repeated: true },
    { no: 2, name: "calendars", kind: "message", T: ListEventsResponse_EventCalendar, repeated: true },
    { no: 3, name: "userAttendeeStatuses", kind: "message", T: ListEventsResponse_UserAttendeeStatus, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListEventsResponse {
    return new ListEventsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListEventsResponse {
    return new ListEventsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListEventsResponse {
    return new ListEventsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListEventsResponse | PlainMessage<ListEventsResponse> | undefined, b: ListEventsResponse | PlainMessage<ListEventsResponse> | undefined): boolean {
    return proto3.util.equals(ListEventsResponse, a, b);
  }
}

/**
 * @generated from message protogen.ListEventsResponse.EventCalendar
 */
export class ListEventsResponse_EventCalendar extends Message<ListEventsResponse_EventCalendar> {
  /**
   * @generated from field: string integrationRef = 1;
   */
  integrationRef = "";

  /**
   * @generated from field: string calendarId = 2;
   */
  calendarId = "";

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: string accessScope = 4;
   */
  accessScope = "";

  constructor(data?: PartialMessage<ListEventsResponse_EventCalendar>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListEventsResponse.EventCalendar";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "integrationRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "calendarId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "accessScope", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListEventsResponse_EventCalendar {
    return new ListEventsResponse_EventCalendar().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListEventsResponse_EventCalendar {
    return new ListEventsResponse_EventCalendar().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListEventsResponse_EventCalendar {
    return new ListEventsResponse_EventCalendar().fromJsonString(jsonString, options);
  }

  static equals(a: ListEventsResponse_EventCalendar | PlainMessage<ListEventsResponse_EventCalendar> | undefined, b: ListEventsResponse_EventCalendar | PlainMessage<ListEventsResponse_EventCalendar> | undefined): boolean {
    return proto3.util.equals(ListEventsResponse_EventCalendar, a, b);
  }
}

/**
 * @generated from message protogen.ListEventsResponse.UserAttendeeStatus
 */
export class ListEventsResponse_UserAttendeeStatus extends Message<ListEventsResponse_UserAttendeeStatus> {
  /**
   * @generated from field: string eventRef = 1;
   */
  eventRef = "";

  /**
   * @generated from field: string attendeeRef = 2;
   */
  attendeeRef = "";

  /**
   * @generated from field: string attendeeStatus = 3;
   */
  attendeeStatus = "";

  constructor(data?: PartialMessage<ListEventsResponse_UserAttendeeStatus>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListEventsResponse.UserAttendeeStatus";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "eventRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "attendeeRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "attendeeStatus", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListEventsResponse_UserAttendeeStatus {
    return new ListEventsResponse_UserAttendeeStatus().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListEventsResponse_UserAttendeeStatus {
    return new ListEventsResponse_UserAttendeeStatus().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListEventsResponse_UserAttendeeStatus {
    return new ListEventsResponse_UserAttendeeStatus().fromJsonString(jsonString, options);
  }

  static equals(a: ListEventsResponse_UserAttendeeStatus | PlainMessage<ListEventsResponse_UserAttendeeStatus> | undefined, b: ListEventsResponse_UserAttendeeStatus | PlainMessage<ListEventsResponse_UserAttendeeStatus> | undefined): boolean {
    return proto3.util.equals(ListEventsResponse_UserAttendeeStatus, a, b);
  }
}

/**
 * @generated from message protogen.AdvisorCalendarSearchRequest
 */
export class AdvisorCalendarSearchRequest extends Message<AdvisorCalendarSearchRequest> {
  /**
   * @generated from field: string query = 1;
   */
  query = "";

  /**
   * @generated from field: repeated string familyRefs = 2;
   */
  familyRefs: string[] = [];

  /**
   * @generated from field: bool includeAdvisorEvents = 3;
   */
  includeAdvisorEvents = false;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit = 0;

  constructor(data?: PartialMessage<AdvisorCalendarSearchRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AdvisorCalendarSearchRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "familyRefs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "includeAdvisorEvents", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdvisorCalendarSearchRequest {
    return new AdvisorCalendarSearchRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdvisorCalendarSearchRequest {
    return new AdvisorCalendarSearchRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdvisorCalendarSearchRequest {
    return new AdvisorCalendarSearchRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AdvisorCalendarSearchRequest | PlainMessage<AdvisorCalendarSearchRequest> | undefined, b: AdvisorCalendarSearchRequest | PlainMessage<AdvisorCalendarSearchRequest> | undefined): boolean {
    return proto3.util.equals(AdvisorCalendarSearchRequest, a, b);
  }
}

/**
 * @generated from message protogen.AdvisorCalendarSearchResponse
 */
export class AdvisorCalendarSearchResponse extends Message<AdvisorCalendarSearchResponse> {
  /**
   * @generated from field: repeated protogen.EventNotice eventNotices = 1;
   */
  eventNotices: EventNotice[] = [];

  constructor(data?: PartialMessage<AdvisorCalendarSearchResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AdvisorCalendarSearchResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "eventNotices", kind: "message", T: EventNotice, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdvisorCalendarSearchResponse {
    return new AdvisorCalendarSearchResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdvisorCalendarSearchResponse {
    return new AdvisorCalendarSearchResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdvisorCalendarSearchResponse {
    return new AdvisorCalendarSearchResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AdvisorCalendarSearchResponse | PlainMessage<AdvisorCalendarSearchResponse> | undefined, b: AdvisorCalendarSearchResponse | PlainMessage<AdvisorCalendarSearchResponse> | undefined): boolean {
    return proto3.util.equals(AdvisorCalendarSearchResponse, a, b);
  }
}

/**
 * @generated from message protogen.MemberCalendarSearchRequest
 */
export class MemberCalendarSearchRequest extends Message<MemberCalendarSearchRequest> {
  /**
   * @generated from field: string query = 1;
   */
  query = "";

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  constructor(data?: PartialMessage<MemberCalendarSearchRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.MemberCalendarSearchRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MemberCalendarSearchRequest {
    return new MemberCalendarSearchRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MemberCalendarSearchRequest {
    return new MemberCalendarSearchRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MemberCalendarSearchRequest {
    return new MemberCalendarSearchRequest().fromJsonString(jsonString, options);
  }

  static equals(a: MemberCalendarSearchRequest | PlainMessage<MemberCalendarSearchRequest> | undefined, b: MemberCalendarSearchRequest | PlainMessage<MemberCalendarSearchRequest> | undefined): boolean {
    return proto3.util.equals(MemberCalendarSearchRequest, a, b);
  }
}

/**
 * @generated from message protogen.MemberCalendarSearchResponse
 */
export class MemberCalendarSearchResponse extends Message<MemberCalendarSearchResponse> {
  /**
   * @generated from field: repeated protogen.EventNotice eventNotices = 1;
   */
  eventNotices: EventNotice[] = [];

  constructor(data?: PartialMessage<MemberCalendarSearchResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.MemberCalendarSearchResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "eventNotices", kind: "message", T: EventNotice, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MemberCalendarSearchResponse {
    return new MemberCalendarSearchResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MemberCalendarSearchResponse {
    return new MemberCalendarSearchResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MemberCalendarSearchResponse {
    return new MemberCalendarSearchResponse().fromJsonString(jsonString, options);
  }

  static equals(a: MemberCalendarSearchResponse | PlainMessage<MemberCalendarSearchResponse> | undefined, b: MemberCalendarSearchResponse | PlainMessage<MemberCalendarSearchResponse> | undefined): boolean {
    return proto3.util.equals(MemberCalendarSearchResponse, a, b);
  }
}

/**
 * @generated from message protogen.ListEventsBySourceRequest
 */
export class ListEventsBySourceRequest extends Message<ListEventsBySourceRequest> {
  /**
   * @generated from field: string sourceEntityType = 1;
   */
  sourceEntityType = "";

  /**
   * @generated from field: string sourceEntityRef = 2;
   */
  sourceEntityRef = "";

  constructor(data?: PartialMessage<ListEventsBySourceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListEventsBySourceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sourceEntityType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "sourceEntityRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListEventsBySourceRequest {
    return new ListEventsBySourceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListEventsBySourceRequest {
    return new ListEventsBySourceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListEventsBySourceRequest {
    return new ListEventsBySourceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListEventsBySourceRequest | PlainMessage<ListEventsBySourceRequest> | undefined, b: ListEventsBySourceRequest | PlainMessage<ListEventsBySourceRequest> | undefined): boolean {
    return proto3.util.equals(ListEventsBySourceRequest, a, b);
  }
}

/**
 * @generated from message protogen.ListEventsBySourceResponse
 */
export class ListEventsBySourceResponse extends Message<ListEventsBySourceResponse> {
  /**
   * @generated from field: repeated protogen.CalendarEvent events = 1;
   */
  events: CalendarEvent[] = [];

  constructor(data?: PartialMessage<ListEventsBySourceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListEventsBySourceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "events", kind: "message", T: CalendarEvent, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListEventsBySourceResponse {
    return new ListEventsBySourceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListEventsBySourceResponse {
    return new ListEventsBySourceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListEventsBySourceResponse {
    return new ListEventsBySourceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListEventsBySourceResponse | PlainMessage<ListEventsBySourceResponse> | undefined, b: ListEventsBySourceResponse | PlainMessage<ListEventsBySourceResponse> | undefined): boolean {
    return proto3.util.equals(ListEventsBySourceResponse, a, b);
  }
}

/**
 * @generated from message protogen.ListExternalEventsBySourceRequest
 */
export class ListExternalEventsBySourceRequest extends Message<ListExternalEventsBySourceRequest> {
  /**
   * @generated from field: string sourceEntityType = 1;
   */
  sourceEntityType = "";

  /**
   * @generated from field: string sourceEntityRef = 2;
   */
  sourceEntityRef = "";

  constructor(data?: PartialMessage<ListExternalEventsBySourceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListExternalEventsBySourceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sourceEntityType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "sourceEntityRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListExternalEventsBySourceRequest {
    return new ListExternalEventsBySourceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListExternalEventsBySourceRequest {
    return new ListExternalEventsBySourceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListExternalEventsBySourceRequest {
    return new ListExternalEventsBySourceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListExternalEventsBySourceRequest | PlainMessage<ListExternalEventsBySourceRequest> | undefined, b: ListExternalEventsBySourceRequest | PlainMessage<ListExternalEventsBySourceRequest> | undefined): boolean {
    return proto3.util.equals(ListExternalEventsBySourceRequest, a, b);
  }
}

/**
 * @generated from message protogen.ListExternalEventsBySourceResponse
 */
export class ListExternalEventsBySourceResponse extends Message<ListExternalEventsBySourceResponse> {
  /**
   * @generated from field: repeated protogen.EventNotice events = 1;
   */
  events: EventNotice[] = [];

  constructor(data?: PartialMessage<ListExternalEventsBySourceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListExternalEventsBySourceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "events", kind: "message", T: EventNotice, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListExternalEventsBySourceResponse {
    return new ListExternalEventsBySourceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListExternalEventsBySourceResponse {
    return new ListExternalEventsBySourceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListExternalEventsBySourceResponse {
    return new ListExternalEventsBySourceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListExternalEventsBySourceResponse | PlainMessage<ListExternalEventsBySourceResponse> | undefined, b: ListExternalEventsBySourceResponse | PlainMessage<ListExternalEventsBySourceResponse> | undefined): boolean {
    return proto3.util.equals(ListExternalEventsBySourceResponse, a, b);
  }
}

/**
 * @generated from message protogen.UpdateCalendarEventRequest
 */
export class UpdateCalendarEventRequest extends Message<UpdateCalendarEventRequest> {
  /**
   * @generated from field: string eventRef = 1;
   */
  eventRef = "";

  /**
   * @generated from field: string updatedTitle = 2;
   */
  updatedTitle = "";

  /**
   * @generated from field: protogen.ContentUpdates updatedDescription = 3;
   */
  updatedDescription?: ContentUpdates;

  /**
   * @generated from field: int64 updatedStartSecUTC = 4;
   */
  updatedStartSecUTC = protoInt64.zero;

  /**
   * @generated from field: int64 updatedEndSecUTC = 5;
   */
  updatedEndSecUTC = protoInt64.zero;

  /**
   * @generated from field: bool updatedAllDay = 6;
   */
  updatedAllDay = false;

  /**
   * For all day events we need to specifically store the start and end dates so there's no
   * ambiguity on timezone converted dates.
   *
   * @generated from field: string updatedStartDisplayDate = 7;
   */
  updatedStartDisplayDate = "";

  /**
   * @generated from field: string updatedEndDisplayDate = 8;
   */
  updatedEndDisplayDate = "";

  /**
   * @generated from field: protogen.RecurringUnit updatedRecurringUnit = 10;
   */
  updatedRecurringUnit = RecurringUnit.RecurringUnit_UNSPECIFIED;

  /**
   * @generated from field: int32 updatedRecurringInterval = 11;
   */
  updatedRecurringInterval = 0;

  /**
   * @generated from field: int64 updatedRecurringUntilSecUTC = 12;
   */
  updatedRecurringUntilSecUTC = protoInt64.zero;

  /**
   * Email addresses.
   *
   * @generated from field: repeated string updatedInvitees = 13;
   */
  updatedInvitees: string[] = [];

  /**
   * @generated from field: repeated protogen.EventReminder updatedReminders = 14;
   */
  updatedReminders: EventReminder[] = [];

  /**
   * @generated from field: string updatedDisplayTimezone = 15;
   */
  updatedDisplayTimezone = "";

  /**
   * @generated from field: bool shouldUpdateDisplayTimezone = 16;
   */
  shouldUpdateDisplayTimezone = false;

  /**
   * @generated from field: bool shouldUpdateLocation = 17;
   */
  shouldUpdateLocation = false;

  /**
   * @generated from field: string updateLocation = 18;
   */
  updateLocation = "";

  /**
   * @generated from field: bool shouldUpdateAllDay = 19;
   */
  shouldUpdateAllDay = false;

  /**
   * @generated from field: string updatedTransparency = 20;
   */
  updatedTransparency = "";

  /**
   * @generated from field: string updatedVideoRef = 21;
   */
  updatedVideoRef = "";

  /**
   * Advanced recurrence options
   *
   * Days of week [0-6] for Sun-Sat
   *
   * @generated from field: repeated int32 updatedRecurringByDay = 22;
   */
  updatedRecurringByDay: number[] = [];

  /**
   * End after X occurrences (0 means not set)
   *
   * @generated from field: int32 updatedRecurringCount = 23;
   */
  updatedRecurringCount = 0;

  /**
   * Days of month [1-31]
   *
   * @generated from field: repeated int32 updatedRecurringByMonthDay = 24;
   */
  updatedRecurringByMonthDay: number[] = [];

  /**
   * E.g., 2 for "2nd Tuesday" (0 means not set)
   *
   * @generated from field: int32 updatedRecurringBySetPos = 25;
   */
  updatedRecurringBySetPos = 0;

  /**
   * @generated from field: bool shouldUpdateRecurringByDay = 26;
   */
  shouldUpdateRecurringByDay = false;

  /**
   * @generated from field: bool shouldUpdateRecurringCount = 27;
   */
  shouldUpdateRecurringCount = false;

  /**
   * @generated from field: bool shouldUpdateRecurringByMonthDay = 28;
   */
  shouldUpdateRecurringByMonthDay = false;

  /**
   * @generated from field: bool shouldUpdateRecurringBySetPos = 29;
   */
  shouldUpdateRecurringBySetPos = false;

  /**
   * If specified, move/write event to this external calendar integration
   *
   * @generated from field: string targetIntegrationRef = 30;
   */
  targetIntegrationRef = "";

  /**
   * @generated from field: string targetCalendarId = 31;
   */
  targetCalendarId = "";

  /**
   * @generated from field: bool updateAllInstances = 32;
   */
  updateAllInstances = false;

  /**
   * @generated from field: bool notifyCalendarOwner = 33;
   */
  notifyCalendarOwner = false;

  /**
   * @generated from field: string updatedVisibility = 34;
   */
  updatedVisibility = "";

  constructor(data?: PartialMessage<UpdateCalendarEventRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateCalendarEventRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "eventRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "updatedTitle", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "updatedDescription", kind: "message", T: ContentUpdates },
    { no: 4, name: "updatedStartSecUTC", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "updatedEndSecUTC", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "updatedAllDay", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "updatedStartDisplayDate", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "updatedEndDisplayDate", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "updatedRecurringUnit", kind: "enum", T: proto3.getEnumType(RecurringUnit) },
    { no: 11, name: "updatedRecurringInterval", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "updatedRecurringUntilSecUTC", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 13, name: "updatedInvitees", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 14, name: "updatedReminders", kind: "message", T: EventReminder, repeated: true },
    { no: 15, name: "updatedDisplayTimezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "shouldUpdateDisplayTimezone", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "shouldUpdateLocation", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 18, name: "updateLocation", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "shouldUpdateAllDay", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 20, name: "updatedTransparency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "updatedVideoRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "updatedRecurringByDay", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 23, name: "updatedRecurringCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 24, name: "updatedRecurringByMonthDay", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 25, name: "updatedRecurringBySetPos", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 26, name: "shouldUpdateRecurringByDay", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 27, name: "shouldUpdateRecurringCount", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 28, name: "shouldUpdateRecurringByMonthDay", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 29, name: "shouldUpdateRecurringBySetPos", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 30, name: "targetIntegrationRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 31, name: "targetCalendarId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 32, name: "updateAllInstances", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 33, name: "notifyCalendarOwner", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 34, name: "updatedVisibility", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateCalendarEventRequest {
    return new UpdateCalendarEventRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateCalendarEventRequest {
    return new UpdateCalendarEventRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateCalendarEventRequest {
    return new UpdateCalendarEventRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateCalendarEventRequest | PlainMessage<UpdateCalendarEventRequest> | undefined, b: UpdateCalendarEventRequest | PlainMessage<UpdateCalendarEventRequest> | undefined): boolean {
    return proto3.util.equals(UpdateCalendarEventRequest, a, b);
  }
}

/**
 * @generated from message protogen.UpdateCalendarEventResponse
 */
export class UpdateCalendarEventResponse extends Message<UpdateCalendarEventResponse> {
  /**
   * @generated from field: protogen.CalendarEvent event = 1;
   */
  event?: CalendarEvent;

  /**
   * @generated from field: protogen.EventNotice notice = 2;
   */
  notice?: EventNotice;

  constructor(data?: PartialMessage<UpdateCalendarEventResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateCalendarEventResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "event", kind: "message", T: CalendarEvent },
    { no: 2, name: "notice", kind: "message", T: EventNotice },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateCalendarEventResponse {
    return new UpdateCalendarEventResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateCalendarEventResponse {
    return new UpdateCalendarEventResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateCalendarEventResponse {
    return new UpdateCalendarEventResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateCalendarEventResponse | PlainMessage<UpdateCalendarEventResponse> | undefined, b: UpdateCalendarEventResponse | PlainMessage<UpdateCalendarEventResponse> | undefined): boolean {
    return proto3.util.equals(UpdateCalendarEventResponse, a, b);
  }
}

/**
 * @generated from message protogen.DeleteCalendarEventRequest
 */
export class DeleteCalendarEventRequest extends Message<DeleteCalendarEventRequest> {
  /**
   * @generated from field: string eventRef = 1;
   */
  eventRef = "";

  /**
   * @generated from field: int64 originalEventStartSec = 2;
   */
  originalEventStartSec = protoInt64.zero;

  constructor(data?: PartialMessage<DeleteCalendarEventRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.DeleteCalendarEventRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "eventRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "originalEventStartSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteCalendarEventRequest {
    return new DeleteCalendarEventRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteCalendarEventRequest {
    return new DeleteCalendarEventRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteCalendarEventRequest {
    return new DeleteCalendarEventRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteCalendarEventRequest | PlainMessage<DeleteCalendarEventRequest> | undefined, b: DeleteCalendarEventRequest | PlainMessage<DeleteCalendarEventRequest> | undefined): boolean {
    return proto3.util.equals(DeleteCalendarEventRequest, a, b);
  }
}

/**
 * @generated from message protogen.DeleteCalendarEventResponse
 */
export class DeleteCalendarEventResponse extends Message<DeleteCalendarEventResponse> {
  constructor(data?: PartialMessage<DeleteCalendarEventResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.DeleteCalendarEventResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteCalendarEventResponse {
    return new DeleteCalendarEventResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteCalendarEventResponse {
    return new DeleteCalendarEventResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteCalendarEventResponse {
    return new DeleteCalendarEventResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteCalendarEventResponse | PlainMessage<DeleteCalendarEventResponse> | undefined, b: DeleteCalendarEventResponse | PlainMessage<DeleteCalendarEventResponse> | undefined): boolean {
    return proto3.util.equals(DeleteCalendarEventResponse, a, b);
  }
}

/**
 * @generated from message protogen.UpdateAttendeeStatusRequest
 */
export class UpdateAttendeeStatusRequest extends Message<UpdateAttendeeStatusRequest> {
  /**
   * @generated from field: string status = 1;
   */
  status = "";

  /**
   * @generated from field: string token = 2;
   */
  token = "";

  constructor(data?: PartialMessage<UpdateAttendeeStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateAttendeeStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAttendeeStatusRequest {
    return new UpdateAttendeeStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAttendeeStatusRequest {
    return new UpdateAttendeeStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAttendeeStatusRequest {
    return new UpdateAttendeeStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAttendeeStatusRequest | PlainMessage<UpdateAttendeeStatusRequest> | undefined, b: UpdateAttendeeStatusRequest | PlainMessage<UpdateAttendeeStatusRequest> | undefined): boolean {
    return proto3.util.equals(UpdateAttendeeStatusRequest, a, b);
  }
}

/**
 * @generated from message protogen.UpdateAttendeeStatusResponse
 */
export class UpdateAttendeeStatusResponse extends Message<UpdateAttendeeStatusResponse> {
  constructor(data?: PartialMessage<UpdateAttendeeStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateAttendeeStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAttendeeStatusResponse {
    return new UpdateAttendeeStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAttendeeStatusResponse {
    return new UpdateAttendeeStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAttendeeStatusResponse {
    return new UpdateAttendeeStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAttendeeStatusResponse | PlainMessage<UpdateAttendeeStatusResponse> | undefined, b: UpdateAttendeeStatusResponse | PlainMessage<UpdateAttendeeStatusResponse> | undefined): boolean {
    return proto3.util.equals(UpdateAttendeeStatusResponse, a, b);
  }
}

/**
 * @generated from message protogen.GetCalendarEventRequest
 */
export class GetCalendarEventRequest extends Message<GetCalendarEventRequest> {
  /**
   * @generated from field: string eventRef = 1;
   */
  eventRef = "";

  constructor(data?: PartialMessage<GetCalendarEventRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetCalendarEventRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "eventRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCalendarEventRequest {
    return new GetCalendarEventRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCalendarEventRequest {
    return new GetCalendarEventRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCalendarEventRequest {
    return new GetCalendarEventRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCalendarEventRequest | PlainMessage<GetCalendarEventRequest> | undefined, b: GetCalendarEventRequest | PlainMessage<GetCalendarEventRequest> | undefined): boolean {
    return proto3.util.equals(GetCalendarEventRequest, a, b);
  }
}

/**
 * @generated from message protogen.GetCalendarEventResponse
 */
export class GetCalendarEventResponse extends Message<GetCalendarEventResponse> {
  /**
   * @generated from field: protogen.CalendarEvent event = 1;
   */
  event?: CalendarEvent;

  /**
   * @generated from field: protogen.EventNotice notice = 2;
   */
  notice?: EventNotice;

  constructor(data?: PartialMessage<GetCalendarEventResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetCalendarEventResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "event", kind: "message", T: CalendarEvent },
    { no: 2, name: "notice", kind: "message", T: EventNotice },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCalendarEventResponse {
    return new GetCalendarEventResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCalendarEventResponse {
    return new GetCalendarEventResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCalendarEventResponse {
    return new GetCalendarEventResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCalendarEventResponse | PlainMessage<GetCalendarEventResponse> | undefined, b: GetCalendarEventResponse | PlainMessage<GetCalendarEventResponse> | undefined): boolean {
    return proto3.util.equals(GetCalendarEventResponse, a, b);
  }
}

/**
 * @generated from message protogen.GetExternalCalendarEventRequest
 */
export class GetExternalCalendarEventRequest extends Message<GetExternalCalendarEventRequest> {
  /**
   * @generated from field: string eventRef = 1;
   */
  eventRef = "";

  constructor(data?: PartialMessage<GetExternalCalendarEventRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetExternalCalendarEventRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "eventRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetExternalCalendarEventRequest {
    return new GetExternalCalendarEventRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetExternalCalendarEventRequest {
    return new GetExternalCalendarEventRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetExternalCalendarEventRequest {
    return new GetExternalCalendarEventRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetExternalCalendarEventRequest | PlainMessage<GetExternalCalendarEventRequest> | undefined, b: GetExternalCalendarEventRequest | PlainMessage<GetExternalCalendarEventRequest> | undefined): boolean {
    return proto3.util.equals(GetExternalCalendarEventRequest, a, b);
  }
}

/**
 * @generated from message protogen.GetExternalCalendarEventResponse
 */
export class GetExternalCalendarEventResponse extends Message<GetExternalCalendarEventResponse> {
  /**
   * @generated from field: protogen.EventNotice notice = 1;
   */
  notice?: EventNotice;

  constructor(data?: PartialMessage<GetExternalCalendarEventResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetExternalCalendarEventResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "notice", kind: "message", T: EventNotice },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetExternalCalendarEventResponse {
    return new GetExternalCalendarEventResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetExternalCalendarEventResponse {
    return new GetExternalCalendarEventResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetExternalCalendarEventResponse {
    return new GetExternalCalendarEventResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetExternalCalendarEventResponse | PlainMessage<GetExternalCalendarEventResponse> | undefined, b: GetExternalCalendarEventResponse | PlainMessage<GetExternalCalendarEventResponse> | undefined): boolean {
    return proto3.util.equals(GetExternalCalendarEventResponse, a, b);
  }
}

/**
 * @generated from message protogen.DeleteExternalCalendarEventRequest
 */
export class DeleteExternalCalendarEventRequest extends Message<DeleteExternalCalendarEventRequest> {
  /**
   * @generated from field: string eventRef = 1;
   */
  eventRef = "";

  /**
   * @generated from field: bool deleteAllInstances = 2;
   */
  deleteAllInstances = false;

  constructor(data?: PartialMessage<DeleteExternalCalendarEventRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.DeleteExternalCalendarEventRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "eventRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "deleteAllInstances", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteExternalCalendarEventRequest {
    return new DeleteExternalCalendarEventRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteExternalCalendarEventRequest {
    return new DeleteExternalCalendarEventRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteExternalCalendarEventRequest {
    return new DeleteExternalCalendarEventRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteExternalCalendarEventRequest | PlainMessage<DeleteExternalCalendarEventRequest> | undefined, b: DeleteExternalCalendarEventRequest | PlainMessage<DeleteExternalCalendarEventRequest> | undefined): boolean {
    return proto3.util.equals(DeleteExternalCalendarEventRequest, a, b);
  }
}

/**
 * @generated from message protogen.DeleteExternalCalendarEventResponse
 */
export class DeleteExternalCalendarEventResponse extends Message<DeleteExternalCalendarEventResponse> {
  constructor(data?: PartialMessage<DeleteExternalCalendarEventResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.DeleteExternalCalendarEventResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteExternalCalendarEventResponse {
    return new DeleteExternalCalendarEventResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteExternalCalendarEventResponse {
    return new DeleteExternalCalendarEventResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteExternalCalendarEventResponse {
    return new DeleteExternalCalendarEventResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteExternalCalendarEventResponse | PlainMessage<DeleteExternalCalendarEventResponse> | undefined, b: DeleteExternalCalendarEventResponse | PlainMessage<DeleteExternalCalendarEventResponse> | undefined): boolean {
    return proto3.util.equals(DeleteExternalCalendarEventResponse, a, b);
  }
}

/**
 * @generated from message protogen.CalendarIntegration
 */
export class CalendarIntegration extends Message<CalendarIntegration> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: string status = 3;
   */
  status = "";

  /**
   * @generated from field: int64 createdSec = 4;
   */
  createdSec = protoInt64.zero;

  /**
   * @generated from field: int64 lastAccessedSec = 5;
   */
  lastAccessedSec = protoInt64.zero;

  /**
   * @generated from field: repeated protogen.CalendarIntegration.Calendar calendars = 6;
   */
  calendars: CalendarIntegration_Calendar[] = [];

  /**
   * @generated from field: string accessScope = 7;
   */
  accessScope = "";

  /**
   * @generated from field: string type = 8;
   */
  type = "";

  /**
   * @generated from field: string provider = 9;
   */
  provider = "";

  /**
   * Non-calendar scopes granted on this integration (e.g. gmail.readonly), for the generic
   * integrations UI to show which products are connected.
   *
   * @generated from field: repeated string grantedScopes = 10;
   */
  grantedScopes: string[] = [];

  constructor(data?: PartialMessage<CalendarIntegration>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CalendarIntegration";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "createdSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "lastAccessedSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "calendars", kind: "message", T: CalendarIntegration_Calendar, repeated: true },
    { no: 7, name: "accessScope", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "provider", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "grantedScopes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CalendarIntegration {
    return new CalendarIntegration().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CalendarIntegration {
    return new CalendarIntegration().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CalendarIntegration {
    return new CalendarIntegration().fromJsonString(jsonString, options);
  }

  static equals(a: CalendarIntegration | PlainMessage<CalendarIntegration> | undefined, b: CalendarIntegration | PlainMessage<CalendarIntegration> | undefined): boolean {
    return proto3.util.equals(CalendarIntegration, a, b);
  }
}

/**
 * @generated from message protogen.CalendarIntegration.Calendar
 */
export class CalendarIntegration_Calendar extends Message<CalendarIntegration_Calendar> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string summary = 2;
   */
  summary = "";

  /**
   * @generated from field: bool enabled = 3;
   */
  enabled = false;

  /**
   * @generated from field: string timezone = 4;
   */
  timezone = "";

  /**
   * @generated from field: string role = 5;
   */
  role = "";

  constructor(data?: PartialMessage<CalendarIntegration_Calendar>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CalendarIntegration.Calendar";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "summary", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CalendarIntegration_Calendar {
    return new CalendarIntegration_Calendar().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CalendarIntegration_Calendar {
    return new CalendarIntegration_Calendar().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CalendarIntegration_Calendar {
    return new CalendarIntegration_Calendar().fromJsonString(jsonString, options);
  }

  static equals(a: CalendarIntegration_Calendar | PlainMessage<CalendarIntegration_Calendar> | undefined, b: CalendarIntegration_Calendar | PlainMessage<CalendarIntegration_Calendar> | undefined): boolean {
    return proto3.util.equals(CalendarIntegration_Calendar, a, b);
  }
}

/**
 * @generated from message protogen.ICSExportIntegration
 */
export class ICSExportIntegration extends Message<ICSExportIntegration> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string status = 2;
   */
  status = "";

  /**
   * @generated from field: int64 createdSec = 3;
   */
  createdSec = protoInt64.zero;

  /**
   * @generated from field: int64 lastAccessedSec = 4;
   */
  lastAccessedSec = protoInt64.zero;

  /**
   * @generated from field: string name = 5;
   */
  name = "";

  /**
   * Not always present (sorta secret).
   *
   * @generated from field: string icsUrlPath = 6;
   */
  icsUrlPath = "";

  constructor(data?: PartialMessage<ICSExportIntegration>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ICSExportIntegration";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "createdSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "lastAccessedSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "icsUrlPath", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ICSExportIntegration {
    return new ICSExportIntegration().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ICSExportIntegration {
    return new ICSExportIntegration().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ICSExportIntegration {
    return new ICSExportIntegration().fromJsonString(jsonString, options);
  }

  static equals(a: ICSExportIntegration | PlainMessage<ICSExportIntegration> | undefined, b: ICSExportIntegration | PlainMessage<ICSExportIntegration> | undefined): boolean {
    return proto3.util.equals(ICSExportIntegration, a, b);
  }
}

/**
 * @generated from message protogen.GetCalendarIntegrationsRequest
 */
export class GetCalendarIntegrationsRequest extends Message<GetCalendarIntegrationsRequest> {
  /**
   * @generated from field: bool includeMemberEmailProviders = 1;
   */
  includeMemberEmailProviders = false;

  constructor(data?: PartialMessage<GetCalendarIntegrationsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetCalendarIntegrationsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "includeMemberEmailProviders", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCalendarIntegrationsRequest {
    return new GetCalendarIntegrationsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCalendarIntegrationsRequest {
    return new GetCalendarIntegrationsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCalendarIntegrationsRequest {
    return new GetCalendarIntegrationsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCalendarIntegrationsRequest | PlainMessage<GetCalendarIntegrationsRequest> | undefined, b: GetCalendarIntegrationsRequest | PlainMessage<GetCalendarIntegrationsRequest> | undefined): boolean {
    return proto3.util.equals(GetCalendarIntegrationsRequest, a, b);
  }
}

/**
 * @generated from message protogen.GetCalendarIntegrationsResponse
 */
export class GetCalendarIntegrationsResponse extends Message<GetCalendarIntegrationsResponse> {
  /**
   * @generated from field: repeated protogen.CalendarIntegration importIntegrations = 1;
   */
  importIntegrations: CalendarIntegration[] = [];

  /**
   * @generated from field: repeated protogen.ICSExportIntegration exportIntegrations = 2;
   */
  exportIntegrations: ICSExportIntegration[] = [];

  /**
   * Optionally return a map of email providers we should suggest the client utilizes.
   *
   * @generated from field: map<string, string> emailProviders = 3;
   */
  emailProviders: { [key: string]: string } = {};

  constructor(data?: PartialMessage<GetCalendarIntegrationsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetCalendarIntegrationsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "importIntegrations", kind: "message", T: CalendarIntegration, repeated: true },
    { no: 2, name: "exportIntegrations", kind: "message", T: ICSExportIntegration, repeated: true },
    { no: 3, name: "emailProviders", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCalendarIntegrationsResponse {
    return new GetCalendarIntegrationsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCalendarIntegrationsResponse {
    return new GetCalendarIntegrationsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCalendarIntegrationsResponse {
    return new GetCalendarIntegrationsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCalendarIntegrationsResponse | PlainMessage<GetCalendarIntegrationsResponse> | undefined, b: GetCalendarIntegrationsResponse | PlainMessage<GetCalendarIntegrationsResponse> | undefined): boolean {
    return proto3.util.equals(GetCalendarIntegrationsResponse, a, b);
  }
}

/**
 * @generated from message protogen.GetFamilyCalendarIntegrationsRequest
 */
export class GetFamilyCalendarIntegrationsRequest extends Message<GetFamilyCalendarIntegrationsRequest> {
  /**
   * @generated from field: string familyRef = 1;
   */
  familyRef = "";

  constructor(data?: PartialMessage<GetFamilyCalendarIntegrationsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetFamilyCalendarIntegrationsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "familyRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFamilyCalendarIntegrationsRequest {
    return new GetFamilyCalendarIntegrationsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFamilyCalendarIntegrationsRequest {
    return new GetFamilyCalendarIntegrationsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFamilyCalendarIntegrationsRequest {
    return new GetFamilyCalendarIntegrationsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetFamilyCalendarIntegrationsRequest | PlainMessage<GetFamilyCalendarIntegrationsRequest> | undefined, b: GetFamilyCalendarIntegrationsRequest | PlainMessage<GetFamilyCalendarIntegrationsRequest> | undefined): boolean {
    return proto3.util.equals(GetFamilyCalendarIntegrationsRequest, a, b);
  }
}

/**
 * @generated from message protogen.GetFamilyCalendarIntegrationsResponse
 */
export class GetFamilyCalendarIntegrationsResponse extends Message<GetFamilyCalendarIntegrationsResponse> {
  /**
   * @generated from field: repeated protogen.CalendarIntegration importIntegrations = 1;
   */
  importIntegrations: CalendarIntegration[] = [];

  /**
   * @generated from field: repeated protogen.ICSExportIntegration exportIntegrations = 2;
   */
  exportIntegrations: ICSExportIntegration[] = [];

  constructor(data?: PartialMessage<GetFamilyCalendarIntegrationsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetFamilyCalendarIntegrationsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "importIntegrations", kind: "message", T: CalendarIntegration, repeated: true },
    { no: 2, name: "exportIntegrations", kind: "message", T: ICSExportIntegration, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFamilyCalendarIntegrationsResponse {
    return new GetFamilyCalendarIntegrationsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFamilyCalendarIntegrationsResponse {
    return new GetFamilyCalendarIntegrationsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFamilyCalendarIntegrationsResponse {
    return new GetFamilyCalendarIntegrationsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetFamilyCalendarIntegrationsResponse | PlainMessage<GetFamilyCalendarIntegrationsResponse> | undefined, b: GetFamilyCalendarIntegrationsResponse | PlainMessage<GetFamilyCalendarIntegrationsResponse> | undefined): boolean {
    return proto3.util.equals(GetFamilyCalendarIntegrationsResponse, a, b);
  }
}

/**
 * @generated from message protogen.CreateCalendarIntegrationRequest
 */
export class CreateCalendarIntegrationRequest extends Message<CreateCalendarIntegrationRequest> {
  /**
   * @generated from field: string accessCode = 1;
   */
  accessCode = "";

  /**
   * @generated from field: string accessScope = 2;
   */
  accessScope = "";

  /**
   * @generated from field: string accessRedirectUri = 3;
   */
  accessRedirectUri = "";

  /**
   * @generated from field: string calendarUrl = 4;
   */
  calendarUrl = "";

  /**
   * @generated from field: string calendarType = 5;
   */
  calendarType = "";

  /**
   * @generated from field: string familyRef = 6;
   */
  familyRef = "";

  /**
   * @generated from field: protogen.UploadAttachment uploadedFile = 7;
   */
  uploadedFile?: UploadAttachment;

  constructor(data?: PartialMessage<CreateCalendarIntegrationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CreateCalendarIntegrationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "accessCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "accessScope", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "accessRedirectUri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "calendarUrl", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "calendarType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "familyRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "uploadedFile", kind: "message", T: UploadAttachment },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateCalendarIntegrationRequest {
    return new CreateCalendarIntegrationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateCalendarIntegrationRequest {
    return new CreateCalendarIntegrationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateCalendarIntegrationRequest {
    return new CreateCalendarIntegrationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateCalendarIntegrationRequest | PlainMessage<CreateCalendarIntegrationRequest> | undefined, b: CreateCalendarIntegrationRequest | PlainMessage<CreateCalendarIntegrationRequest> | undefined): boolean {
    return proto3.util.equals(CreateCalendarIntegrationRequest, a, b);
  }
}

/**
 * @generated from message protogen.CreateCalendarIntegrationResponse
 */
export class CreateCalendarIntegrationResponse extends Message<CreateCalendarIntegrationResponse> {
  /**
   * @generated from field: protogen.CalendarIntegration integration = 1;
   */
  integration?: CalendarIntegration;

  constructor(data?: PartialMessage<CreateCalendarIntegrationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CreateCalendarIntegrationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "integration", kind: "message", T: CalendarIntegration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateCalendarIntegrationResponse {
    return new CreateCalendarIntegrationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateCalendarIntegrationResponse {
    return new CreateCalendarIntegrationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateCalendarIntegrationResponse {
    return new CreateCalendarIntegrationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateCalendarIntegrationResponse | PlainMessage<CreateCalendarIntegrationResponse> | undefined, b: CreateCalendarIntegrationResponse | PlainMessage<CreateCalendarIntegrationResponse> | undefined): boolean {
    return proto3.util.equals(CreateCalendarIntegrationResponse, a, b);
  }
}

/**
 * Generic integrations flow (separate from CreateCalendarIntegration). A single Google OAuth grant
 * may carry calendar and/or gmail scopes; the backend exchanges the code once and records calendar
 * access plus any gmail scope on one integration row. grantedScope is the space-delimited scope
 * string Google returns on the callback.
 *
 * @generated from message protogen.ConnectGoogleIntegrationRequest
 */
export class ConnectGoogleIntegrationRequest extends Message<ConnectGoogleIntegrationRequest> {
  /**
   * @generated from field: string accessCode = 1;
   */
  accessCode = "";

  /**
   * @generated from field: string accessRedirectUri = 2;
   */
  accessRedirectUri = "";

  /**
   * @generated from field: string grantedScope = 3;
   */
  grantedScope = "";

  /**
   * @generated from field: string familyRef = 4;
   */
  familyRef = "";

  constructor(data?: PartialMessage<ConnectGoogleIntegrationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ConnectGoogleIntegrationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "accessCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "accessRedirectUri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "grantedScope", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "familyRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConnectGoogleIntegrationRequest {
    return new ConnectGoogleIntegrationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConnectGoogleIntegrationRequest {
    return new ConnectGoogleIntegrationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConnectGoogleIntegrationRequest {
    return new ConnectGoogleIntegrationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ConnectGoogleIntegrationRequest | PlainMessage<ConnectGoogleIntegrationRequest> | undefined, b: ConnectGoogleIntegrationRequest | PlainMessage<ConnectGoogleIntegrationRequest> | undefined): boolean {
    return proto3.util.equals(ConnectGoogleIntegrationRequest, a, b);
  }
}

/**
 * @generated from message protogen.ConnectGoogleIntegrationResponse
 */
export class ConnectGoogleIntegrationResponse extends Message<ConnectGoogleIntegrationResponse> {
  /**
   * @generated from field: protogen.CalendarIntegration integration = 1;
   */
  integration?: CalendarIntegration;

  constructor(data?: PartialMessage<ConnectGoogleIntegrationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ConnectGoogleIntegrationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "integration", kind: "message", T: CalendarIntegration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConnectGoogleIntegrationResponse {
    return new ConnectGoogleIntegrationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConnectGoogleIntegrationResponse {
    return new ConnectGoogleIntegrationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConnectGoogleIntegrationResponse {
    return new ConnectGoogleIntegrationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ConnectGoogleIntegrationResponse | PlainMessage<ConnectGoogleIntegrationResponse> | undefined, b: ConnectGoogleIntegrationResponse | PlainMessage<ConnectGoogleIntegrationResponse> | undefined): boolean {
    return proto3.util.equals(ConnectGoogleIntegrationResponse, a, b);
  }
}

/**
 * @generated from message protogen.UpdateCalendarIntegrationRequest
 */
export class UpdateCalendarIntegrationRequest extends Message<UpdateCalendarIntegrationRequest> {
  /**
   * @generated from field: string integrationRef = 1;
   */
  integrationRef = "";

  /**
   * @generated from field: bool deactivate = 2;
   */
  deactivate = false;

  /**
   * @generated from field: bool activate = 3;
   */
  activate = false;

  /**
   * @generated from field: string enableCalendarId = 4;
   */
  enableCalendarId = "";

  /**
   * @generated from field: string disableCalendarId = 5;
   */
  disableCalendarId = "";

  constructor(data?: PartialMessage<UpdateCalendarIntegrationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateCalendarIntegrationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "integrationRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "deactivate", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "activate", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "enableCalendarId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "disableCalendarId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateCalendarIntegrationRequest {
    return new UpdateCalendarIntegrationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateCalendarIntegrationRequest {
    return new UpdateCalendarIntegrationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateCalendarIntegrationRequest {
    return new UpdateCalendarIntegrationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateCalendarIntegrationRequest | PlainMessage<UpdateCalendarIntegrationRequest> | undefined, b: UpdateCalendarIntegrationRequest | PlainMessage<UpdateCalendarIntegrationRequest> | undefined): boolean {
    return proto3.util.equals(UpdateCalendarIntegrationRequest, a, b);
  }
}

/**
 * @generated from message protogen.UpdateCalendarIntegrationResponse
 */
export class UpdateCalendarIntegrationResponse extends Message<UpdateCalendarIntegrationResponse> {
  /**
   * @generated from field: protogen.CalendarIntegration integration = 1;
   */
  integration?: CalendarIntegration;

  constructor(data?: PartialMessage<UpdateCalendarIntegrationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateCalendarIntegrationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "integration", kind: "message", T: CalendarIntegration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateCalendarIntegrationResponse {
    return new UpdateCalendarIntegrationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateCalendarIntegrationResponse {
    return new UpdateCalendarIntegrationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateCalendarIntegrationResponse {
    return new UpdateCalendarIntegrationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateCalendarIntegrationResponse | PlainMessage<UpdateCalendarIntegrationResponse> | undefined, b: UpdateCalendarIntegrationResponse | PlainMessage<UpdateCalendarIntegrationResponse> | undefined): boolean {
    return proto3.util.equals(UpdateCalendarIntegrationResponse, a, b);
  }
}

/**
 * @generated from message protogen.GenerateICSUrlRequest
 */
export class GenerateICSUrlRequest extends Message<GenerateICSUrlRequest> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  constructor(data?: PartialMessage<GenerateICSUrlRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GenerateICSUrlRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GenerateICSUrlRequest {
    return new GenerateICSUrlRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GenerateICSUrlRequest {
    return new GenerateICSUrlRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GenerateICSUrlRequest {
    return new GenerateICSUrlRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GenerateICSUrlRequest | PlainMessage<GenerateICSUrlRequest> | undefined, b: GenerateICSUrlRequest | PlainMessage<GenerateICSUrlRequest> | undefined): boolean {
    return proto3.util.equals(GenerateICSUrlRequest, a, b);
  }
}

/**
 * @generated from message protogen.GenerateICSUrlResponse
 */
export class GenerateICSUrlResponse extends Message<GenerateICSUrlResponse> {
  /**
   * @generated from field: protogen.ICSExportIntegration export = 1;
   */
  export?: ICSExportIntegration;

  constructor(data?: PartialMessage<GenerateICSUrlResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GenerateICSUrlResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "export", kind: "message", T: ICSExportIntegration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GenerateICSUrlResponse {
    return new GenerateICSUrlResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GenerateICSUrlResponse {
    return new GenerateICSUrlResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GenerateICSUrlResponse {
    return new GenerateICSUrlResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GenerateICSUrlResponse | PlainMessage<GenerateICSUrlResponse> | undefined, b: GenerateICSUrlResponse | PlainMessage<GenerateICSUrlResponse> | undefined): boolean {
    return proto3.util.equals(GenerateICSUrlResponse, a, b);
  }
}

/**
 * @generated from message protogen.RevealICSUrlRequest
 */
export class RevealICSUrlRequest extends Message<RevealICSUrlRequest> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  constructor(data?: PartialMessage<RevealICSUrlRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.RevealICSUrlRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RevealICSUrlRequest {
    return new RevealICSUrlRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RevealICSUrlRequest {
    return new RevealICSUrlRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RevealICSUrlRequest {
    return new RevealICSUrlRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RevealICSUrlRequest | PlainMessage<RevealICSUrlRequest> | undefined, b: RevealICSUrlRequest | PlainMessage<RevealICSUrlRequest> | undefined): boolean {
    return proto3.util.equals(RevealICSUrlRequest, a, b);
  }
}

/**
 * @generated from message protogen.RevealICSUrlResponse
 */
export class RevealICSUrlResponse extends Message<RevealICSUrlResponse> {
  /**
   * @generated from field: protogen.ICSExportIntegration export = 1;
   */
  export?: ICSExportIntegration;

  constructor(data?: PartialMessage<RevealICSUrlResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.RevealICSUrlResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "export", kind: "message", T: ICSExportIntegration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RevealICSUrlResponse {
    return new RevealICSUrlResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RevealICSUrlResponse {
    return new RevealICSUrlResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RevealICSUrlResponse {
    return new RevealICSUrlResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RevealICSUrlResponse | PlainMessage<RevealICSUrlResponse> | undefined, b: RevealICSUrlResponse | PlainMessage<RevealICSUrlResponse> | undefined): boolean {
    return proto3.util.equals(RevealICSUrlResponse, a, b);
  }
}

/**
 * @generated from message protogen.UpdateICSUrlRequest
 */
export class UpdateICSUrlRequest extends Message<UpdateICSUrlRequest> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string updatedStatus = 2;
   */
  updatedStatus = "";

  /**
   * @generated from field: string updatedName = 3;
   */
  updatedName = "";

  constructor(data?: PartialMessage<UpdateICSUrlRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateICSUrlRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "updatedStatus", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "updatedName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateICSUrlRequest {
    return new UpdateICSUrlRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateICSUrlRequest {
    return new UpdateICSUrlRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateICSUrlRequest {
    return new UpdateICSUrlRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateICSUrlRequest | PlainMessage<UpdateICSUrlRequest> | undefined, b: UpdateICSUrlRequest | PlainMessage<UpdateICSUrlRequest> | undefined): boolean {
    return proto3.util.equals(UpdateICSUrlRequest, a, b);
  }
}

/**
 * @generated from message protogen.UpdateICSUrlResponse
 */
export class UpdateICSUrlResponse extends Message<UpdateICSUrlResponse> {
  /**
   * @generated from field: protogen.ICSExportIntegration export = 1;
   */
  export?: ICSExportIntegration;

  constructor(data?: PartialMessage<UpdateICSUrlResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateICSUrlResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "export", kind: "message", T: ICSExportIntegration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateICSUrlResponse {
    return new UpdateICSUrlResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateICSUrlResponse {
    return new UpdateICSUrlResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateICSUrlResponse {
    return new UpdateICSUrlResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateICSUrlResponse | PlainMessage<UpdateICSUrlResponse> | undefined, b: UpdateICSUrlResponse | PlainMessage<UpdateICSUrlResponse> | undefined): boolean {
    return proto3.util.equals(UpdateICSUrlResponse, a, b);
  }
}

/**
 * @generated from message protogen.RefreshCalendarsRequest
 */
export class RefreshCalendarsRequest extends Message<RefreshCalendarsRequest> {
  /**
   * @generated from field: string familyRef = 1;
   */
  familyRef = "";

  constructor(data?: PartialMessage<RefreshCalendarsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.RefreshCalendarsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "familyRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RefreshCalendarsRequest {
    return new RefreshCalendarsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RefreshCalendarsRequest {
    return new RefreshCalendarsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RefreshCalendarsRequest {
    return new RefreshCalendarsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RefreshCalendarsRequest | PlainMessage<RefreshCalendarsRequest> | undefined, b: RefreshCalendarsRequest | PlainMessage<RefreshCalendarsRequest> | undefined): boolean {
    return proto3.util.equals(RefreshCalendarsRequest, a, b);
  }
}

/**
 * @generated from message protogen.RefreshCalendarsResponse
 */
export class RefreshCalendarsResponse extends Message<RefreshCalendarsResponse> {
  constructor(data?: PartialMessage<RefreshCalendarsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.RefreshCalendarsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RefreshCalendarsResponse {
    return new RefreshCalendarsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RefreshCalendarsResponse {
    return new RefreshCalendarsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RefreshCalendarsResponse {
    return new RefreshCalendarsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RefreshCalendarsResponse | PlainMessage<RefreshCalendarsResponse> | undefined, b: RefreshCalendarsResponse | PlainMessage<RefreshCalendarsResponse> | undefined): boolean {
    return proto3.util.equals(RefreshCalendarsResponse, a, b);
  }
}

/**
 * @generated from message protogen.GetUpcomingEventCallsRequest
 */
export class GetUpcomingEventCallsRequest extends Message<GetUpcomingEventCallsRequest> {
  /**
   * @generated from field: repeated string familyRefs = 1;
   */
  familyRefs: string[] = [];

  constructor(data?: PartialMessage<GetUpcomingEventCallsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetUpcomingEventCallsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "familyRefs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetUpcomingEventCallsRequest {
    return new GetUpcomingEventCallsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetUpcomingEventCallsRequest {
    return new GetUpcomingEventCallsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetUpcomingEventCallsRequest {
    return new GetUpcomingEventCallsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetUpcomingEventCallsRequest | PlainMessage<GetUpcomingEventCallsRequest> | undefined, b: GetUpcomingEventCallsRequest | PlainMessage<GetUpcomingEventCallsRequest> | undefined): boolean {
    return proto3.util.equals(GetUpcomingEventCallsRequest, a, b);
  }
}

/**
 * @generated from message protogen.GetUpcomingEventCallsResponse
 */
export class GetUpcomingEventCallsResponse extends Message<GetUpcomingEventCallsResponse> {
  /**
   * @generated from field: repeated protogen.EventNotice eventNotices = 1;
   */
  eventNotices: EventNotice[] = [];

  constructor(data?: PartialMessage<GetUpcomingEventCallsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetUpcomingEventCallsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "eventNotices", kind: "message", T: EventNotice, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetUpcomingEventCallsResponse {
    return new GetUpcomingEventCallsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetUpcomingEventCallsResponse {
    return new GetUpcomingEventCallsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetUpcomingEventCallsResponse {
    return new GetUpcomingEventCallsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetUpcomingEventCallsResponse | PlainMessage<GetUpcomingEventCallsResponse> | undefined, b: GetUpcomingEventCallsResponse | PlainMessage<GetUpcomingEventCallsResponse> | undefined): boolean {
    return proto3.util.equals(GetUpcomingEventCallsResponse, a, b);
  }
}

